<template>
  <div class="casi-loading-container">
    <div class="loading-card">
      <!-- ElementUI 加载动画 -->
      <i class="el-icon-loading loading-icon"></i>

      <!-- 主提示文字 -->
      <h3 class="loading-title">正在登录中</h3>
      <!-- 辅助提示文字 -->
      <p class="loading-desc">请稍候，系统正在完成身份验证...</p>
    </div>
  </div>
</template>

<script>
import { getOrgUrlInstance } from "../utils/authUtils";
export default {
  name: "casiLoading",
  data() {
    return {
      // 统一认证工具类实例
      authUtils: getOrgUrlInstance(this.$http),
    };
  },
  mounted() {
    this.authUtils.getOrgUrl().then(url => {
      // 拼接参数：casiFlag=true
      const currentParams = new URLSearchParams(window.location.search);
      const appendParams = new URLSearchParams();
      const autoCasi = currentParams.get("autoCasi");
      const idp = currentParams.get("idp");

      if (autoCasi) {
        appendParams.append("casiFlag", "true");
      }

      if (idp) {
        appendParams.append("idp", idp);
      }

      const queryString = appendParams.toString();
      const newUrl = queryString ? url + (url.includes("?") ? "&" : "?") + queryString : url;
      window.location.href = newUrl;
    });
  },
  methods: {},
};
</script>

<style scoped>
/* 基础样式 - 浅色模式 */
.casi-loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: background 0.3s ease;
}

/* 夜间模式样式 */
.oauth-loading-container.dark-mode {
  background: linear-gradient(135deg, #1a1c23 0%, #2d3748 100%);
}

/* 加载卡片 - 浅色模式 */
.loading-card {
  width: 420px;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

/* 夜间模式卡片样式 */
.dark-mode .loading-card {
  background: #2d3748;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* 响应式适配 */
@media (max-width: 576px) {
  .loading-card {
    width: 90%;
    padding: 40px 20px;
  }
}

/* 加载图标样式 */
.loading-icon {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 24px;
  animation: rotate 2s linear infinite;
  /* 夜间模式图标颜色微调 */
  transition: color 0.3s ease;
}
.dark-mode .loading-icon {
  color: #66b1ff;
}

/* 标题样式 */
.loading-title {
  font-size: 20px;
  color: #303133;
  margin: 0 0 12px 0;
  font-weight: 600;
  transition: color 0.3s ease;
}
.dark-mode .loading-title {
  color: #e5e7eb;
}

/* 旋转动画 */
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
